import { API_URL } from "@/config";
import { axios } from "@/lib/axios";
import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export const MessagesDemo = () => {
    const search = useLocation().search;
    const phone = new URLSearchParams(search).get('phone')?.trim();
    const bizPhone = '+18886043196';
    const [messages, setMessages] = useState<any[]>();
    const [message, setMessage] = useState<string>();

    const sendMessage = useCallback(async (message) => {
        if (!message) return;

        axios.post(`${API_URL}/messaging/messages/${bizPhone}/+${phone}`, { message })
            .catch(err => console.log(err))
            .finally(() => setMessage(''));
    }, [phone, bizPhone]);

    useEffect(() => {
        axios.get(`${API_URL}/messaging/messages/${bizPhone}/+${phone}`)
            .then((messages: any) => setMessages(messages))
            .catch(err => console.log(err));
    }, []);

    return (
        <div className="flex flex-col bg-gray-100">
            <div className="bg-gradient-to-r from-blue-500 to-purple-500 py-4">
                <h1 className="text-center text-2xl font-bold">Business Phone: {bizPhone}</h1>
            </div>
            <div className="flex-grow overflow-y-auto">
                <div className="flex flex-col space-y-2 p-4">
                    {(messages || []).map(msg => (msg.from === bizPhone) ?
                        (
                            <div className="flex items-center self-end rounded-xl rounded-tr bg-blue-500 py-2 px-3">
                                <p>{msg.from}: {msg.message}</p>
                            </div>
                        ) : (
                        <div className="flex items-center self-start rounded-xl rounded-tl bg-gray-300 py-2 px-3">
                            <p>{msg.from}: {msg.message}</p>
                        </div>
                        )
                    )}
                </div>
            </div>
            <div className="flex items-center p-4">
                <input value={message} type="text" onChange={ev => setMessage(ev.target.value)} placeholder="Type your message..." className="w-full rounded-lg border border-gray-300 px-4 py-2" />
                <button className="ml-2 rounded-lg bg-blue-500 px-4 py-2" onClick={() => sendMessage(message)}>Send</button>
            </div>
      </div>
    );
}